import assetPath from '/app/xinglets/lebenslauf/components/frame/src/assets/lebenslauf-logo-dark.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')